var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_102",
    "data-name": "\\uC0AC\\uAC01\\uD615 102",
    width: 156,
    height: 156,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(13.032 6.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_159",
    "data-name": "\\uD328\\uC2A4 159",
    d: "M115.1,47.86a15.639,15.639,0,0,0-8.8.652A15.965,15.965,0,0,0,92.62,41.018l-4.235.652A15.639,15.639,0,0,0,73.723,31.243H70.465V18.863a16.29,16.29,0,0,0-18.9-16.616,16.616,16.616,0,0,0-13.032,16.29v48.22l-7.819-7.819a15.965,15.965,0,0,0-11.4-4.887A14.987,14.987,0,0,0,8.236,58.937,13.358,13.358,0,0,0,4,68.711,25.739,25.739,0,0,0,8.236,81.744c3.91,7.168,27.694,48.22,34.861,60.275a6.19,6.19,0,0,0,5.539,3.258h61.252a6.516,6.516,0,0,0,6.516-4.887l11.077-43.007a4.235,4.235,0,0,0,.326-1.955V64.476A16.942,16.942,0,0,0,115.1,47.86Zm-9.774,84.384H52.22c-8.8-14.661-29.323-50.5-32.907-57.016-.326-.652-3.584-5.865-2.281-7.168l2.281-.977a3.584,3.584,0,0,1,2.281.977l18.9,19.548a6.516,6.516,0,0,0,10.752-4.561V18.211a3.258,3.258,0,0,1,6.516,0V63.824a6.19,6.19,0,0,0,6.19,6.516h0a6.516,6.516,0,0,0,6.516-6.516V47.534a3.1,3.1,0,1,1,6.19,0V67.082A6.516,6.516,0,0,0,83.171,73.6h0a6.516,6.516,0,0,0,6.516-6.516V57.308a3.108,3.108,0,1,1,6.19,0V73.6a6.516,6.516,0,0,0,6.516,6.516h0a6.19,6.19,0,0,0,6.19-6.516V63.824a3.258,3.258,0,0,1,6.516,0V94.776a4.236,4.236,0,0,1-.326,1.955Z",
    transform: "translate(-4 -2.035)",
    fill: "#989ebf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerPoint);
export default __webpack_public_path__ + "static/media/finger_point.7adf1a3ad4c7bbab520b114691b5ed1e.svg";
export { ForwardRef as ReactComponent };